let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ick8a")).then(() => parcelRequire('3WADt'));